import AutoPlaceModule from 'diagram-js/lib/features/auto-place';

import MyAutoPlace from './myAutoPlace';

export default {
  __depends__: [ AutoPlaceModule ],
  __init__: [ 'myAutoPlace' ],
  myAutoPlace: [ 'type', MyAutoPlace ]
};